// extracted by css-extract-rspack-plugin
export default {"root":"MIt9jjRQ3s5EFLVH"};